import styled from "styled-components";

export const CreationTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

export const StepperContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${(props) => props.theme?.colors?.white || "#fff"};
  padding: 16px 0 8px;
`;

